// @ts-nocheck

import * as S from './UpdateDocument.styles'
import {
  Container as GridContainer,
  Column,
  Row
} from '../../../../components/grid/GridSystem'
import { AppBar } from '../../../../components/appBar/AppBar'
import { PurchaseSummary } from '../components/purchaseSummary/PurchaseSummary'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { clearCheckoutState } from '../../../../redux/Checkout/actions'
import { Hidden, InputMask } from 'applaus-ui-kit'
import { DescriptionCard } from '../../../../components/descriptionCard/DescriptionCard'
import { ButtonBack } from '../../../../components/buttonBack/buttonBack'
import { ReduxState } from '../../../../redux/rootReducer'
import { useEffect } from 'react'
import history from '../../../../routes/services/history'
import moment from 'moment'
import { editProfileService } from '../../../../api/services/profile/editProfileService'
import { editUserSuccessAction } from '../../../../redux/User/actions'
import { validationSchema } from './validationSchema'
import { useWindowSize } from '../../../../hooks/useWindowSize'
import { clearLoading, setLoading } from '../../../../redux/Loading/actions'
import {
  clearModalState,
  setModalState
} from '../../../../redux/Modal/Actions/actionsModal'
import cpfValidate from '../../../../utils/cpfValidator'

export const UpdateDocument = () => {
  const dispatch = useDispatch()
  const { eventData, ticketState } = useSelector(
    (state: ReduxState) => state.CheckoutReducer.data
  )
  const UserState = useSelector((state: ReduxState) => state.UserReducer)
  const { isDesktop } = useWindowSize()

  const initialDocument = cpfValidate(UserState.document || '')
    ? UserState.document
    : ''

  const formik = useFormik({
    initialValues: {
      document: initialDocument
    },
    validationSchema,
    onSubmit: async (values) => {
      dispatch(setLoading())
      try {
        const data = await editProfileService({
          document: values.document.replace(/\D/g, '')
        })

        dispatch(
          editUserSuccessAction({
            ...data,
            document: data.document
          })
        )
        dispatch(clearLoading())
      } catch (err: any) {
        dispatch(clearLoading())
        const apiMessage = err?.response?.data?.message

        if (apiMessage === 'document already exists') {
          formik.setFieldError('document', 'CPF já cadastrado.')
          return
        }

        dispatch(
          setModalState({
            open: true,
            variant: 'error',
            message: 'Não foi possível atualizar o CPF',
            description: 'Tente novamente mais tarde',
            click: () => dispatch(clearModalState())
          })
        )
      }
    }
  })

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <S.Container>
      <Hidden mobile>
        <AppBar />
      </Hidden>

      <GridContainer>
        <Hidden tablet desktop>
          <ButtonBack
            title="Voltar"
            click={() => {
              dispatch(clearCheckoutState())
              history.push(`/event/${eventData?.id}`)
            }}
          />
        </Hidden>
        <Row>
          <Hidden mobile tablet>
            <Column spacing={isDesktop ? 3 : 0} desktop={6}>
              <PurchaseSummary
                eventAddress={eventData?.address.street ?? ''}
                eventDate={
                  moment(eventData?.eventItems[0].dates[0])
                    .locale('pt-br')
                    .format('ll [ás] HH[h]mm') ?? ''
                }
                tickets={ticketState ?? []}
                titleTicket={eventData?.name ?? ''}
              />
            </Column>
          </Hidden>
          <Column spacing={isDesktop ? 3 : 0} mobile={4} desktop={6} tablet={8}>
            <S.Wrapper>
              <DescriptionCard title="Atualize seu CPF" />
              <S.HelperText>
                Para continuar com o pagamento, informe um CPF válido.
              </S.HelperText>

              <S.Form onSubmit={formik.handleSubmit}>
                <InputMask
                  mask={'999.999.999-99'}
                  name="document"
                  label="*CPF"
                  placeholder="Digite seu CPF"
                  texterror={formik.errors.document}
                  error={
                    Boolean(formik.errors.document) && formik.touched.document
                  }
                  onChange={formik.handleChange('document')}
                  value={formik.values.document || ''}
                  fullWidth
                />

                <S.ButtonBox>
                  <Hidden mobile>
                    <ButtonBack
                      title="Voltar"
                      click={() => {
                        dispatch(clearCheckoutState())
                        history.push(`/event/${eventData?.id}`)
                      }}
                    />
                  </Hidden>

                  <div>
                    <S.ButtonStyled
                      fullWidth
                      variant="contained"
                      size="large"
                      color="primary"
                      type="submit">
                      Continuar
                    </S.ButtonStyled>
                  </div>
                </S.ButtonBox>
              </S.Form>
            </S.Wrapper>
          </Column>
        </Row>
      </GridContainer>
    </S.Container>
  )
}
